import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx} from "../Shared/FormField";
import dayjs from "dayjs";
import {addressConfig} from "./components/address";

export const returnServiceConfig = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="returnService.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="returnService.verification">Verification</Trans>,
            "description": <Trans i18nKey="returnService.emailConfirm.description">Please enter your job number <u>or</u> your serial number and your e-mail address for verification.</Trans>,
            "fields": [
                {
                    "component": "serialnumberreturnservice",
                    "size": "full",
                    "required": true,
                },
            ],
        },
        // {
        //     "heading": <Trans i18nKey="orderEntry.emailConfirm">Confirm your E-Mail Address</Trans>,
        //     "description": <Trans i18nKey="orderEntry.emailConfirm.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
        //     "fields": [
        //         {
        //             "name": "email",
        //             "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        //             "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        //             "size": "full",
        //             "type": "email",
        //             "required": true,
        //         },
        //     ],
        // },
        {
            "heading": <Trans i18nKey="returnService.parcelService">Parcel service</Trans>,
            "description": <Trans i18nKey="returnService.problemDescription.description">Please select the parcel service.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "parcelserviceselect",
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return orderEntryState.emailConfirmed;
            },
        },
        {
            "heading": <Trans i18nKey="returnService.pickupInformation">Pickup information</Trans>,
            "description": <Trans i18nKey="returnService.pickupInformation.description">Please select a date for the pickup at your address</Trans>,
            "fields": [
                {
                    "name": "day",
                    "label": <Trans i18nKey="returnService.form.day">Day</Trans>,
                    "size": "half",
                    "type": "datepicker",
                    "required": true,
                    "preventWeekends": true,
                    "maxDate": dayjs().add(30, "day").toISOString(),
                },
                {
                    "size": "full",
                    "component": "timeslots",
                    "conditionFunction": (values, orderEntryState) => {
                        return values.day;
                    }
                }
            ],
            "conditionFunction": (values, formState) => {
                return formState.parcel_services.find(service => String(service.key) == values.parcel_service)?.collection;
            },
        },
        {
            "heading": <Trans i18nKey="returnService.addressContact">Sender / Collection address</Trans>,
            "description": <Trans i18nKey="returnService.addressContact.description">Please verify your address and contact data.</Trans>,
            "fields": [
                ...addressConfig,
            ],
            "conditionFunction": (values, formState) => {
                return formState.emailConfirmed;
            },
        },
        {
            "heading": <Trans i18nKey="returnService.privacyStatement">Terms of service</Trans>,
            "description": <Trans i18nKey="returnService.privacyStatement.description"></Trans>,
            "fields": [
                {
                    "name": "terms_of_service",
                    "label": <Trans getRaw i18nKey="returnService.privacyStatement.label">I have read and accept the <a href="https://b2x.com/privacy-policy/">Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                }
            ],
            "conditionFunction": (values, formState) => {
                return formState.emailConfirmed;
            },
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "id": "submitbutton",
                    "text": <Trans i18nKey="common.send">Send</Trans>,
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, formState) => {
                        return formState.emailConfirmed;
                    },
                }
            ]
        }
    ]
}
